export default function Map() {
  return (
    <section id="location" className="bg-slate-50 py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-8">
        {/* TITLE */}
        <div className="text-center mb-12">
          <h2 className="mt-4 text-3xl md:text-4xl font-bold text-slate-900">
            Find Us Easily
          </h2>

          <p className="mt-3 text-slate-600 max-w-2xl mx-auto">
            Visit our rental property and see the available units in person. We
            are located in a convenient and accessible area.
          </p>
        </div>

        {/* CONTENT */}
        <div className=" gap-8 items-stretch">
          {/* MAP */}
          <div className="lg:col-span-2 overflow-hidden rounded-2xl shadow-xl min-h-[350px]">
            <iframe
              title="StaySuite Location Map"
              src="https://www.google.com/maps?q=Manila%20Philippines&output=embed"
              className="h-[350px] md:h-[450px] w-full border-0"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  )
}
